import axios from "axios";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "./asyncActions";
import setAuthToken from "../../utils/auth/setAuthToken";
import {
  DELETE_CURRENT_DOC,
  HOME,
  LOGOUT,
  SET_CURRENT_DOC,
  SHIABUD_FORM,
  SHIABUD_SUBMITTED,
  TEMP_LIC,
  TEMP_LIC_REQ,
  UPLOAD_DOC,
  UPLOAD_DOC_ERROR,
  UPLOAD_SIGNED_DOC,
  SIGNATURE_ERROR,
  SET_NOTIF
} from "./types";
import { API_URL } from './api'

// Login User
// export const sendOtp=(data)=>
export const handleError = (error) => async (dispatch) => {
  console.log(error);
  if (error.response.status == 401) {
    dispatch({
      type: LOGOUT,
    });
    dispatch(asyncActionError("אנא היכנס מחדש"));
  } else if (
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    dispatch(asyncActionError(error.response.data.message));
  } else {
    dispatch(asyncActionError("Server error"));
  }
};
export const getHomeData = (docNum) => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/home-page/`;

    const res = await axios.post(url, { docNum: docNum });
    console.log(res);

    if (res.data.data.error) {
      dispatch(asyncActionError(res.data.data.error));
    } else {
      dispatch({
        type: HOME,
        payload: res.data,
      });

      // In order to test, clean token from localStorage
      // loadUser(); // Gets user from the backend

      dispatch(asyncActionFinish());
    }
  } catch (error) {
    handleError(error);
  }
};

export const setNotif = (data) => async (dispatch) => {
  
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/set-notif-status/`;
    
    const res = await axios.post(url, data);
    console.log(res);
    dispatch({
      type: SET_NOTIF,
    });
    dispatch(asyncActionFinish());
  } catch (error) {
    handleError(error);
  }
};

export const getShiabudForm = () => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/get-shiabud-form/`;

    const res = await axios.get(url);
    console.log(res);

    if (res.data.error) {
      dispatch(asyncActionError(res.data.error));
    } else {
      dispatch({
        type: SHIABUD_FORM,
        payload: res.data,
      });

      // In order to test, clean token from localStorage
      // loadUser(); // Gets user from the backend

      dispatch(asyncActionFinish());
    }
  } catch (error) {
    handleError(error);
  }
};
export const shiabudSubmit = (data) => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/shiabud-form-request`;
    const res = await axios.post(url, data);
    console.log(res);
    dispatch({
      type: SHIABUD_SUBMITTED,
    });
    dispatch(asyncActionFinish());
  } catch (error) {
    handleError(error);
  }
};

export const getTempLic = () => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/get-temp-lic`;
    const res = await axios.get(url);
    console.log("getTempLic", res.data.data);
    dispatch({
      type: TEMP_LIC,
      payload: res.data.data,
    });
    dispatch(asyncActionFinish());
  } catch (error) {
    handleError(error);
  }
};

export const tempLicRequest = (data) => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}/portal/temp-lic-request`;
    const res = await axios.post(url, data);
    dispatch({
      type: TEMP_LIC_REQ,
    });
    dispatch(asyncActionFinish());
  } catch (error) {}
};
export const uploadDoc = (formData) => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    dispatch({
      type: UPLOAD_DOC_ERROR,
      payload: false
    });

    const url = `${API_URL}/portal/upload-doc`;
    const res = await axios.post(url, formData);
    console.log(formData);
    console.log(res);
    if (res.data.success) {
      dispatch({
        type: UPLOAD_DOC,
        payload: formData.DocType
      });
      dispatch(asyncActionFinish());
    } else {
      dispatch({
        type: UPLOAD_DOC_ERROR,
        payload: true
      });
      dispatch(asyncActionError(res.message));
    }
  } catch (error) {
    handleError(error);
  }
};
export const currentDoc=(doc)=>{
  console.log('currentDoc')
  return {
    type: SET_CURRENT_DOC,
    payload: doc
  }
}
export const deleteCurrentDoc=()=>{
  return{
    type:DELETE_CURRENT_DOC,
  }
}
export const uploadSignedDoc=(data)=>async dispatch=>{
  dispatch(asyncActionStart());
  try {
    dispatch({
      type: SIGNATURE_ERROR,
      payload: false
    });

    const url = `${API_URL}/portal/upload-signed-doc`;
    const res = await axios.post(url, data);
    console.log(res);
 
    if (res.data.success) {
      dispatch({
        type: UPLOAD_SIGNED_DOC,
        payload: {type: data.DocType, url: res?.data?.url}
      });
      dispatch(asyncActionFinish());
    } else {
      dispatch({
        type: SIGNATURE_ERROR,
        payload: true
      });
      dispatch(asyncActionError(res?.data?.result ?? 'Error signing the doc'));
    }
  } catch (error) {
    handleError(error);
  }
}